// extracted by mini-css-extract-plugin
module.exports = {"signInModalV2":"az_dA"};